<template>
  <div>
    <Bar :data="barData" :options="barOptions" />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Bar } from 'vue-chartjs'
import { computed } from 'vue'

const props = defineProps({
  dataset: {
    type: Object,
    default: () => ({}),
  },
  options: {
    type: Object,
    default: () => ({}),
  },
  sortData: {
    type: Boolean,
    default: false,
  },
})

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ChartDataLabels,
)

const barData = ref({
  labels: [],
  datasets: [
    {
      data: [],
    },
  ],
})

const barOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  ...props.options,
  datasets: {
    bar: {
      backgroundColor: 'oklch(67.3% 0.182 276.935)', // indigo-400
    },
  },
  scales: {
    x: {
      grace: 5,
      ...props.options.scales?.x,
    },
    y: {
      grace: 10,
      ...props.options.scales?.y,
    },
  },
  plugins: {
    datalabels: false,
    ...props.options.plugins,
    legend: {
      display: false,
      ...props.options.plugins?.legend,
    },
  },
}))

watch(
  () => props.dataset,
  (dataset) => {
    if (dataset.data) {
      let data = dataset.data
      if (props.sortData) {
        data = Object.entries(data)
          .sort(([, a], [, b]) => b - a)
          .reduce((acc, [label, data]) => {
            acc[label] = data
            return acc
          }, {})
      }

      const labels = Object.keys(data)
      barData.value = {
        labels: labels,
        datasets: [
          {
            label: dataset.label,
            data: labels.map((label) => data[label]),
          },
        ],
      }
    }
  },
  { immediate: true },
)
</script>
